import styled from 'styled-components/macro'

export default styled.header`
  height: ${props => props.theme.header.height};
  padding: ${props => props.theme.padding};
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  z-index: 3;
  width: 100%;
  max-width: ${props => props.theme.maxWidth};
  transition: all 0.3s;
  background: ${props => props.backgroundColor || "white"};
  color: ${props => props.color};

  &.stuck {
    box-shadow: 0px 5px 3px rgba(72, 72, 72, 0.1), 0px -5px 3px rgba(72, 72, 72, 0.1);
    opacity: 0.97;
  }

  &.transparent {
    background-color: transparent;
    &.stuck {
      background: linear-gradient(180deg, black, transparent);
    }
  }
`

const headerTitleWidth = 150

export const HeaderTitle = styled.h1`
  position: absolute;
  font-size: ${props => props.fontSize};
  width: ${`${headerTitleWidth}px`};
  right: calc(50% - ${`${headerTitleWidth / 2}px`});
  text-align: center;
  transition: color 0.5s;
  color: ${props => props.color};
  white-space: nowrap;
  margin: 0;
  text-overflow: ellipsis;
  overflow: hidden;
`
